import React from 'react';
import PropTypes from 'prop-types';
import {COLOR_CODE} from '@/utils/constants/colors';
import {SECTION_TITLES} from '../common/ReviewConstants';
import ActionButtons from '../ActionButtons/ActionButtons';

const {LAST_UPDATED} = SECTION_TITLES.DISPLAY;

const RewardDownload = ({updatedDate}) => {
  return (
    <div className='flex flex-row'>
      <span
        style={{color: COLOR_CODE._DADADA, fontWeight: 500, fontSize: '14px'}}
        className='flex-1 leading-8'>
        {updatedDate && (
          <>
            {LAST_UPDATED} {updatedDate}
          </>
        )}
      </span>
      <ActionButtons />
    </div>
  );
};

RewardDownload.propTypes = {
  updatedDate: PropTypes.string
};

export default RewardDownload;
